module.exports = __webpack_public_path__ + "img/01_iMac-M1-Mockups.2f1f068e.png";